import React from "react";
import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { renderToolTip } from "../helpers/tooltip";
import { Card, Table, OverlayTrigger } from "react-bootstrap";
import { exportData } from "../helpers/utils";

class instanceUserChange extends React.Component {
    constructor(props) {
      super(props);
        this.state = {
            instanceNames: [],
            historicalData: []
        };
    }

    async componentDidMount() {
       await this.getInstanceNames();
    }

    async getInstanceNames() {
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Historic/GetInstanceChangesByInstanceHistoric?category=1&")
        return this.setState({ historicalData: resp })
    }
  
    render() {
        if(this.state.historicalData) {
            let renderLimit = this.state.historicalData.slice(0, 10);
            return (
                <Card className="rounded-4">
                    <Card.Body>
                        <Card.Title>
                            Instance % Change
                            <div className='float-end'>
                                <span className="fullscreen-link" onClick={() => {exportData('UserChange', this.state.historicalData)}}>Export</span>
                            </div>
                        </Card.Title>
                        <Card.Subtitle>
                            Number of Active User Logins current month vs previous month
                        </Card.Subtitle>
                        <Table hover responsive>
                            <thead>
                                <tr className="table-dark">
                                    <th colSpan={2} scope="col">Instance</th>
                                    <th scope="col">Change</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                renderLimit.map(function (n) {
                                return (
                                    <tr key={n.instance}>
                                        <th colSpan={2} scope="row">
                                            {n.instance}
                                        </th>
                                        <OverlayTrigger placement="top" overlay={renderToolTip("instanceUserChange", n)}>
                                            <td>
                                                <span className={Math.sign(n.percentChange) === -1 ? "badge badge-width bg-danger" : "badge badge-width bg-success"}>{n.percentChange}%</span>
                                            </td>
                                        </OverlayTrigger>
                                    </tr>
                                )
                            }, this)}
                            </tbody>
                        </Table>
                        
                    </Card.Body>
                </Card>  
            )
        } 
    };
};

export default instanceUserChange;
